import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-point-notation__icon"
}
const _hoisted_2 = {
  class: "p-point-notation__point",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPoint = _resolveComponent("IconPoint")!

  return (_openBlock(), _createElementBlock("div", {
    class: "p-point-notation",
    style: _normalizeStyle(_ctx.fontStyle)
  }, [
    (_ctx.iconSize !== false)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon", {}, () => [
            _createVNode(_component_IconPoint, {
              "icon-size": _ctx.iconSize,
              "icon-sp-size": _ctx.iconSpSize,
              point_logo: _ctx.point_logo
            }, null, 8, ["icon-size", "icon-sp-size", "point_logo"])
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "p-point-notation__point__num",
        style: _normalizeStyle(_ctx.fontStyle)
      }, _toDisplayString(_ctx.addComma(_ctx.point)), 5),
      _createElementVNode("span", {
        class: "p-point-notation__point__unit",
        style: _normalizeStyle({ fontSize: `${_ctx.fontSize / 2 / 16}rem` }),
        "data-translate-skip": ""
      }, _toDisplayString(_ctx.getUnit()), 5)
    ]),
    (_ctx.signIsExists)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["p-point-notation__sign", `p-point-notation__sign--${_ctx.getSignData.signClassName}`])
        }, _toDisplayString(_ctx.getSignData.signLabel), 3))
      : _createCommentVNode("", true)
  ], 4))
}